@if (previewThumbnails?.length) {
  <div id="mediaSlideShowWrapper" [style.height]="height || '45vh'">
    <div
      [@slideAnimation]="currentIndex"
      class="slider"
      [style.max-height]="previewThumbnails?.length > 1 ? 'calc(100% - 36px)' : '100%'">
      @for (thumb of previewThumbnails; track thumb; let i = $index) {
        @if (currentThumb == thumb) {
          <img
            [src]="thumb"
            draggable="false"
            class="slide auto cursor-pointer"
            [class.invertWhenDark]="invert != null"
            (swiperight)="moveGallery('right')"
            (swipeleft)="moveGallery('left')"
            (click)="imagezoom()" />
        }
      }
      @if (previewThumbnails?.length > 1) {
        <button class="btn btn-icon btn-link arrow prev" (click)="moveGallery('left')">
          <cds-icon shape="angle" direction="left" size="44" />
        </button>
      }
      @if (previewThumbnails?.length > 1) {
        <button class="btn btn-icon btn-link arrow next" (click)="moveGallery('right')">
          <cds-icon shape="angle" direction="right" size="44" />
        </button>
      }
    </div>
    @if (previewThumbnails?.length > 1) {
      <div class="d-f row center mw-100p padding-12-tb">
        @for (thumb of previewThumbnails; track thumb; let i = $index) {
          <cds-icon
            shape="circle"
            [solid]="currentThumb == thumb"
            size="12"
            (click)="changeIndexTo(i)"
            class="cursor-pointer margin-3-lr"></cds-icon>
        }
      </div>
    }
  </div>
}

@if (imageMedia) {
  <app-mediaviewmodal (onClose)="imageMedia = undefined" [media]="imageMedia"></app-mediaviewmodal>
}
